import { Injectable } from '@angular/core';
import { BaseNotifier } from '../../notifiers/base-notifier';
import { Ref } from '../../providers/ref';
import { HeaderState } from '../states/header-state';

@Injectable({ providedIn: 'root' })
export class HeaderNotifier extends BaseNotifier<HeaderState> {
  constructor(ref: Ref) {
    super(ref, {
      isLive: true,
      dropdownOpen: false,
    });
  }

  toggleDropdown() {
    this.setState({
      ...this.state(),
      dropdownOpen: !this.state().dropdownOpen,
    });
  }

  closeDropdown() {
    this.setState({
      ...this.state(),
      dropdownOpen: false,
    });
  }
}
